import { render, staticRenderFns } from "./MasterDataTruck.vue?vue&type=template&id=27c5d020&scoped=true"
import script from "./MasterDataTruck.vue?vue&type=script&lang=js"
export * from "./MasterDataTruck.vue?vue&type=script&lang=js"
import style0 from "./MasterDataTruck.vue?vue&type=style&index=0&id=27c5d020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5d020",
  null
  
)

export default component.exports